import { createFont } from "@tamagui/core";
import { createInterFont } from "@tamagui/font-inter";

const interFont = createInterFont();

export const fonts = {
  body: createFont({
    ...interFont,
    size: {
      1: 12,
      2: 13,
      3: 14,
      4: 16,
      5: 18,
      5.5: 20,
      6: 30,
      7: 22,
      7.5: 24,
      8: 26,
      8.5: 30,
      9: 32,
      9.5: 36,
      10: 38,
      11: 48,
      11.5: 56,
      12: 60,
    },
    letterSpacing: {},
    weight: {
      4: "400",
      5: "700",
      6: "800",
      12: "900",
    },
    lineHeight: {
      1: 14,
      2: 15,
      3: 17,
      4: 20,
      6: 36,
      5: 24,
      7: 29,
      7.5: 30,
      8: 33,
      9: 39,
      10: 46,
    },
  }),

  heading: createFont({
    ...interFont,
    size: {
      2: 16,
      3: 20,
      4: 24,
      5: 28,
      5.5: 30,
      6: 32,
      6.5: 36,
      7: 40,
      8: 48,
      9: 56,
      9.5: 60,
      10: 66,
    },
    letterSpacing: {},
    lineHeight: {
      2: 1.5 * 16,
      3: 1.5 * 20,
      4: 1.5 * 24,
      5: 1.5 * 28,
      5.5: 1.5 * 30,
      6: 1.5 * 32,
      7: 1.5 * 40,
      8: 1.5 * 48,
      9: 1.5 * 56,
      9.5: 1.5 * 60,
      10: 1.5 * 66,
    },
    transform: {
      5: "uppercase",
      6: "none",
    },
    weight: {
      4: "400",
      5: "700",
      6: "800",
      9.5: "900",
    },
  }),
};
